import axios from "axios";
import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import {WEB_SETTINGS_GET, WEB_SETTINGS_UPDATE} from "../../../../constants/api.constants";
import {webSettingsConstants} from "../../../../constants/Web/webSettings.constants";

const requestHeaders = () => ({
    'Content-Type': 'application/json',
    'authToken': getUserToken(),
    'language': getAppLang(),
});

/**
 * Tesisin site ayarlarini anahtar/deger olarak doner.
 * Response: data: { whatsapp_enabled: 1, whatsapp_phone: "+905xxxxxxxxx", ... }
 */
export function getWebSettings() {

    const body = {
        params: {
            property_id: getProperty(),
        }
    };

    return dispatch => {
        dispatch({
            type: 'WEB_SETTINGS_GET',
            payload: axios.post(WEB_SETTINGS_GET, body, {headers: requestHeaders()})
                .then(response => response.data)
        })
    }
}

/**
 * Kismi guncelleme: yalnizca gonderilen anahtarlar degisir, digerleri korunur.
 *
 * updateWebSettings({whatsapp_enabled: 1, whatsapp_phone: '+905551112233'})
 * -> { params: { property_id, settings: { whatsapp_enabled: 1, whatsapp_phone: '...' } } }
 */
export function updateWebSettings(settings) {

    const body = {
        params: {
            property_id: getProperty(),
            settings: settings,
        }
    };

    return dispatch => {
        dispatch({
            type: 'WEB_SETTINGS_UPDATE',
            payload: axios.post(WEB_SETTINGS_UPDATE, body, {headers: requestHeaders()})
                .then(response => response.data)
        })
    }
}

export function clearWebSettingsUpdate() {
    return dispatch => {
        dispatch({
            type: webSettingsConstants.WEB_SETTINGS_UPDATE_CLEAR,
        })
    }
}
